<template>
  <div class="BirthDateChangeFinish">
    <section-header heading="2" ja="誕生月の設定が完了しました"/>
    <div class="description">
      <div>誕生月の設定が完了しました。</div>
      <div class="birth">{{ birthYear }}/{{ birthMonth }}</div>
    </div>
    <normal-btn @click="onBack">戻る</normal-btn>
  </div>
</template>

<script>
import SectionHeader from '../components/SectionHeader'
import NormalBtn from '../components/NormalBtn'

export default {
  name: "BirthDateChangeFinish",
  components: {
    SectionHeader,
    NormalBtn
  },
  data() {
    return {
      birthYear: this.$route.params.year,
      birthMonth: this.$route.params.month,
    }
  },
  methods: {
    onBack() {
      this.$router.push('/setting')
    }
  }
}
</script>

<style scoped>
.description {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
}
.birth {
  margin: 30px 0 0;
  font-size: 12px;
  color: #F63C5B;
}
</style>
